module.exports = __webpack_public_path__ + "img/but_xcx.6980e4b3.png";